module.exports = __webpack_public_path__ + "img/5.a16b58f8.png";